import React from 'react';
import { getUrl, getDescText, getPublishDate } from '../../common/services/builders';

function CareersItem({ entry, settings }) {
    return (
        <div className="careers-listing__item">
            <div className="row">
                <div className="column large-10">
                    {/* <p className="careers-listing__industry">{entry.department}</p> */}
                </div>
            </div>
            <div className="row">
                <div className="column large-6">
                    <p className="careers-listing__role">{entry.title}</p>
                </div>
                <div className="column small-5 medium-4 large-2">
                    <p className="careers-listing__location">{entry.location}</p>
                </div>
                <div className="column small-5 medium-4 large-2">
                    <p className="careers-listing__permanent">{entry.employmentType}</p>
                </div>
            </div>
            <div className="careers-listing__apply">
                <a type="button" href={entry.link} className="btn">Apply</a>
            </div>
        </div>
    );

}
export default CareersItem;